export class PremiumDataGeneration {
  private _current = 0;

  public start(): number {
    return ++this._current;
  }

  public invalidateIfCurrent(generation: number): number | undefined {
    if (!this.isCurrent(generation)) return undefined;
    return ++this._current;
  }

  public invalidate(): number {
    return ++this._current;
  }

  public isCurrent(generation: number): boolean {
    return generation === this._current;
  }
}
